export const LAYOUT = {
  SET_INITIAL_DETAILS: "SET_INITIAL_DETAILS",
  SET_REDUX_KEY: "SET_REDUX_KEY",
  SET_DEFAULT_STATE: "SET_DEFAULT_STATE",
  SET_TEMPLATE: "SET_TEMPLATE",
  SET_VIEW_TYPE: "SET_VIEW_TYPE",
  SET_ADDITIONAL_FIELDS: "SET_ADDITIONAL_FIELDS",
  UPDATE_ADDITIONAL_FIELDS: "UPDATE_ADDITIONAL_FIELDS",
  SET_RESUME_FROM_FILE: "SET_RESUME_FROM_FILE",
};

export const ABOUT_ME = {
  ICON_DETAILS: {
    MAIL: "mail",
    MOBILE: "mobile",
    LINKEDIN: "linkedin",
    GITHUB: "github",
    WEBSITE: "website",
    TWITTER: "twitter",
  },
};
export const LOCAL_STORAGE = {
  SAVED_DATA_KEY: "saved-resume",
};
export const DOWNLOAD_SUCCESSFULL = "Download Successfull ! 🎉🎉";
export const SWITCH_TO_DESKTOP = (performOperation = "Download Resume") =>
  `Switch to Desktop Version to ${performOperation}. 🙏`;
export const SECTION = {
  ABOUT_ME: "aboutme",
  WORK_EX: "workex",
  SKILLS_SECTION: "skills",
  PROJECTS: "projects",
  EDUCATION: "education",
  OPEN_TEMPLATES_DIALOG: "openTemplateDialog",
  CONFIRM_DIALOG: "confirmDialog",
  SWITCH_TO_DEFAULT_RESUME: "Switched To Default Resume 🎉🎉",
  EMPTY_DATA: "Cannot Proceed with Empty Panels ! 😥😥",
  EDIT_MODE_ENABLED: "Edit Mode Enabled ! ✍️ ",
  VIEW_MODE_ENABLED: "View Mode Enabled ! ",
  WEBSITE_FOOTER_MSG: "fast-resume.netlify.com",
  RESUME_NAME: "fast-resume",
  FILE_IMPORT_MESSAGE: "File Data Imported Successfully !  🎉🎉",
  FILE_IMPORT_ERROR_MESSAGE: "Error In Exporting Data To File 😥😥",
  FILE_CORRECT_EXTENSION_MESSAGE:
    "Please select a valid JSON File (Only Exported Using Fast-Resume) 🙏🙏",
  LAST_SAVED_DATA: `Your Previous Work has been Loaded 🎉.  
           Switch To Default View to Reset 🤠🎉`,
  DRAG_SECTIONS:
    "Drag Sections to Reorder Layout ! 🙌 🙌 Use GridLines for Adjusting Layout While Dragging 🔥🔥🔥",
  SAVED_SECTION: (sectionVal) => `${sectionVal} Saved Successfully ! 🎉🎉`,
  SWITCH_TO_MODE: (performOperation, mode = "Edit") =>
    `Switch to ${mode} Mode to ${performOperation}. 🍺🎉`,
  SKILLS: {
    SKILL_SAVED: "Skills Saved Successfully ! 🎉🎉",
    SKILL_ADDED: "Skill Added ! Click Save to Reflect Changes 🎉🎉",
  },
  EDIT_SECTION_NAME: {
    EDIT_MODE: "Click To Edit",
    VIEW_MODE: "Switch To Edit Mode To Edit",
  },
};

export const DOWNLOAD_TYPES = {
  FILE: "file",
  PDF: "pdf",
  JPEG: "jpeg",
};

export const MENU_ITEMS = {
  FOLLOW_CREATOR: {
    VALUE: "About Creator",
    SUB_TEXT: "On Twitter",
  },
  DEFAULT_RESUME: {
    VALUE: "Default Resume",
    SUB_TEXT: "Caution: Remove & Reset Details",
  },
  HELP: {
    VALUE: "Explore Features",
    SUB_TEXT: "Help in Editing Efficienty",
  },
  CHOOSE_TEMPLATE: {
    VALUE: "Choose Template",
    SUB_TEXT: "View Different Resume Layouts",
  },
  EDIT_MODE: {
    VALUE: "Edit Mode",
    SUB_TEXT: "Drag Sections | Change Layout | Edit Data",
  },
  VIEW_MODE: {
    VALUE: "View Mode",
    SUB_TEXT: "Switch After Complete Edit",
  },
  EXPORT_AS_JPEG: {
    VALUE: "Export as JPEG",
    SUB_TEXT: "Generate Single Page Resume",
  },
  EXPORT_AS_FILE: {
    VALUE: "Export To File",
    SUB_TEXT: "Use this file to import the saved state later",
  },
  IMPORT_FROM_FILE: {
    VALUE: "Import From File",
    SUB_TEXT: "Restore Details from File",
  },
  EXPORT_AS_PDF: {
    VALUE: "Export as PDF",
    SUB_TEXT: "Supports Multiple Pages.",
  },
};

export const EXPLORE_FEATURES = {
  heading: "Explore Features",
  features: [
    {
      title: "Download Resume (PDF/JPEG)",
      description:
        "Edit Details in the sections with your information and download your resume.",
    },
    {
      title: "Drag Sections to Rearrange Layout",
      description: "Sections can be dragged accordingly to adjust layout.",
    },
    {
      title: "Click to Edit Section Name",
      description:
        "Section Name can be edited by click. Example, Skills section can be named as Expertise. Work Experience can be changed to Professional Experience.",
    },
    {
      title: "Add New Sections",
      description:
        "Language, Awards and Certificates Section can be added via checkbox toggle option. Please change Section Name if not comfortable with default name.",
    },
    {
      title: "Optional Profile Image",
      description:
        "If you are not comfortable with Profile Image, it can easily be removed with setting showimage flag to false.",
    },
    {
      title: "Choose Template",
      description:
        "Different Layout Templates are available to give your resume a different look.",
    },
    {
      title: "Export/Import File",
      description: `Current Saved Resume Details can be saved into a file. And later on that file can be imported into the application to restore the last saved resume details.
       You can share this file to other person to continue work furthur.`,
    },
    {
      title: "Use 2 Columns Template",
      description:
        "Use this feature for making the default and classic template to have equal width (50%) sections.",
    },
    {
      title: "Choose Template Background",
      description: "Gradient Backgrounds can be selected for any template.",
    },
    {
      title: "Change Skills/Language View Type",
      description:
        "Skills and Language Section can be viewed as Rating, Progress Bar or Default Buttons View.",
    },
    {
      title: "Dark Mode",
      description: "Resume can be downloaded into Dark Mode also.",
    },
    {
      title: "Change Colour",
      description:
        "Resume can be downloaded with any colour you want. Just select the colour using color pallete and download the resume.",
    },
  ],
};
